<div class="m-t-xs flex-center text-link-gray-dark m-b-md" (click)="open()">
  <mat-icon class="m-r-xs">info</mat-icon>{{ 'markdownHelper.helpLabel' | transloco }}
</div>
